import {
  AreaChart,
  Tooltip,
  Area,
  ResponsiveContainer,
  XAxis,
  YAxis,
} from "recharts";
import clsx from "clsx";

const AtidimChartComponent = ({
  device,
  data,
  colorGraph,
  colorText,
  textDescription,
}) => {
  function getHourTitleFromPayload(payload) {
    let hour = payload[0]
      ? payload[0].payload["hour"]
      : payload[1]
      ? payload[1].payload["hour"]
      : "";

    return hour + ` - ${hour.split(":")[0] + ":59"}`;
  }

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      // let currentDay = payload[0].payload.day.split("/");
      return (
        <div className="bg-white shadow-xl p-1 text-sm border rounded-md space-y-1 animate-fadeIn">
          <p className="font-bold">
            {/* {new Date(currentDay[1] + "/" + currentDay[0] + "/" + new Date().getUTCFullYear()).toDateString()} */}
            {/* {label + ":00 - " + label + ":59"} */}
            {getHourTitleFromPayload(payload)}
          </p>
          {payload.map((val, index) => (
            <p className={clsx(`${colorText[index]}`)}>{`${
              payload[index]["dataKey"]
            } ${payload[index].value.toLocaleString()}`}</p>
          ))}
        </div>
      );
    }

    return null;
  };
  if (!device)
    return (
      <div className="flex flex-row px-2">
        <div className="h-48 w-full px-2">No Data from device</div>
      </div>
    );
  else {
    if (data.length < 1)
      return (
        <div className="flex flex-row px-2">
          <div className="h-48 w-full px-2">No Data from device</div>
        </div>
      );
    else {
      // console.log(device);
      // console.log(data);
      let timelineData = data.filter((obj) => {
        return obj["deviceId"] === device;
      });
      if (timelineData.length < 1)
        return (
          <div className="flex flex-row ">
            <div className="h-48 w-full py-16">No Data from device</div>
          </div>
        );
      else {
        let keys = [];
        keys = timelineData[0]["keys"];

        return (
          <div className="flex flex-row px-2">
            <div className="h-48 w-full px-2">
              <ResponsiveContainer>
                <AreaChart
                  key={device}
                  data={timelineData}
                  margin={{
                    top: 10,
                    right: 10,
                    left: 10,
                    bottom: 10,
                  }}
                  id={device}
                >
                  {keys.map((id, index) => (
                    <defs>
                      <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
                        <stop
                          offset="50%"
                          stopColor={colorGraph[index]}
                          opacity={0.9}
                        />
                        <stop
                          offset="95%"
                          stopColor="#8884d8"
                          stopOpacity={0}
                        />
                      </linearGradient>
                    </defs>
                  ))}
                  {/* <Tooltip
                    coordinate={{ x: 0, y: 0 }}
                    offset={0}
                    allowEscapeViewBox={{ x: false, y: true }}
                    content={<CustomTooltip />}
                    key={device}
                  /> */}
                  <XAxis
                    axisLine={false}
                    tick={{ fontSize: "0.5rem" }}
                    interval="preserveStartEnd"
                    height={15}
                    dataKey="hour"
                  />
                  <YAxis
                    axisLine={false}
                    tickLine={true}
                    tick={{ fontSize: "0.6rem" }}
                    width={30}
                    interval="preserveStartEnd"
                    dataKey={"total"}
                  />
                  {keys.map((id, index) => (
                    <Area
                      type="natural"
                      stackId={id}
                      dataKey={id}
                      stroke={colorGraph[index]}
                      strokeWidth={1}
                      fillOpacity={0.6}
                      fill={`url(#${id})`}
                    />
                  ))}
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>
        );
      }
    }
  }
};
export default AtidimChartComponent;
